import HomeComponent from "../default-pages/Home"
import React from "react";
import * as RouterService from "../services/RouterService";
import RouterPage from "../services/RouterPage"

export async function getServerSideProps(context) {
    return await RouterService.getServerSideProps(context)
}

export default function MainPage(props){
    return(
        <RouterPage {...props}/>
    )
}

/*
export function MainPage() {


    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        const start = () => {
            console.log("start");
            setLoading(true);
        };
        const end = () => {
            console.log("findished");
            setLoading(false);
        };
        Router.events.on("routeChangeStart", start);
        Router.events.on("routeChangeComplete", end);
        Router.events.on("routeChangeError", end);

        return () => {
            Router.events.off("routeChangeStart", start);
            Router.events.off("routeChangeComplete", end);
            Router.events.off("routeChangeError", end);
        };
    }, []);




    return (
        <div>
            {loading && (
                <div id="preloader">
                    <div id="loader"></div>
                </div>
            )}

            {!loading && <HomeComponent/>}
        </div>
    )
}
 */
